import { Injectable } from "@angular/core"
import { Apollo, QueryRef } from "apollo-angular"
import gql from "graphql-tag"
import { fragments as submissionQueriesFragments, Post as SubmissionQueriesPost, Customer } from 'modules/submissions/submission.queries'

interface MainQueryVariables {
  writerId: number
  page: number
  perPage: number
  states: string[]
  order: string
}

export interface Post extends SubmissionQueriesPost {
  lastTransitionAt: Date
  customer: Customer
}

export interface Data {
  account: {
    id: number
    posts: {
      totalCount: number
      entries: Post[]
    }
  }
}

const query = gql`
  query WriterAccountPostsListQuery(
    $writerId: Int,
    $page: Int,
    $perPage: Int,
    $states: [String],
    $order: String) {
    account {
      id
      posts(
        writerId: $writerId,
        page: $page,
        perPage: $perPage,
        state: $states,
        order: $order
      ) {
        totalCount
        entries {
          lastTransitionAt
          customer {
            ...SubmissionsPageCustomer
          }
          ...SubmissionsPagePost
        }
      }
    }
  }
  ${submissionQueriesFragments.customer}
  ${submissionQueriesFragments.post}
`

@Injectable({providedIn: 'root'})
export class WriterAccountPostsListQueries {
  constructor(private apollo: Apollo) {}

  mainQuery(variables: MainQueryVariables): QueryRef<Data> {
    return this.apollo.watchQuery<Data>({
      query,
      variables,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only'
    })
  }
}
